# Bootstrapping script for Q&B Platform

if document.currentScript
    c = document.currentScript
    if not c.hasAttribute('data-endpoint')
        throw new Error('Invalid endpoint!')
else
    c = document.querySelector('script[data-endpoint]')

# Check for flow definitions
flow = 'default'
target = 'qandb'

if c.hasAttribute('data-flow')
    flow = c.getAttribute('data-flow')

if c.hasAttribute('data-target')
    target = c.getAttribute('data-target')

endpoint = c.getAttribute('data-endpoint')

# Build the element
head = document.getElementsByTagName('head').item(0)

script = document.createElement('script')
script.type = 'text/javascript'
script.src = endpoint + '/static/app.js'
script.setAttribute('data-quote', '1')
script.setAttribute('data-endpoint', endpoint)
script.setAttribute('data-flow', flow)
script.setAttribute('data-target', target)

if c.hasAttribute('data-user')
    script.setAttribute('data-user', c.getAttribute('data-user'))

if c.hasAttribute('data-verify')
    script.setAttribute('data-verify', c.getAttribute('data-verify'))

if c.hasAttribute('data-debug')
    script.setAttribute('data-debug', '1')

head.appendChild(script)
